import { STATES_MAP } from '@ria-client/supergraph/marketplace/constants';

export const STATE_OPTIONS = Object.entries(STATES_MAP).map(([abbreviation, name]) => ({
  label: name,
  value: abbreviation,
}));

export const DEFAULT_STATE_OPTION = 'CA';
